// extracted by mini-css-extract-plugin
module.exports = {"commissions":"style_commissions__1m2zz","stateCol":"style_stateCol__3DtnP","icon":"style_icon__2eKYU","amount":"style_amount__3gZjj","subtract":"style_subtract__2sSwH"};